import { CheckCircleIcon, Icon as PhosphorIcon, XCircleIcon } from '@phosphor-icons/react'

import { ToastType } from './toast.types'

export const ToastTypeToIconMap: Record<ToastType, PhosphorIcon> = {
  error: XCircleIcon,
  success: CheckCircleIcon,
}
